import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IGeneratePasswordResetTokenParams {
  username: string;
}

export interface IGeneratePasswordResetTokenResult extends IResult {
}

export class GeneratePasswordResetTokenRequest extends Request<IGeneratePasswordResetTokenParams, IGeneratePasswordResetTokenResult> {
  constructor(params: IGeneratePasswordResetTokenParams) {
    super('generatePasswordResetToken', params);
  }
}
